export const WAPRES = 'WAPRES';
export const PARRES = 'PARRES';
export const NORES = 'NORES';
